<template>
  <div class="awards">
    <div class="awards__border-top"></div>
    <div class="awards__content">
      <div class="awards__projects" data-split-context>
        <h4 data-split class="awards__label tt-u ff-mono fs-12 sp-45">
          {{ projectsTitle }}
        </h4>
        <div class="awards__col">
          <div
            class="awards__platform"
            v-for="(awards, platform) in groupedProjects"
            data-split
            :key="platform"
          >
            <span class="awards__platform__title fs-12 sp-16 tt-u">{{
              platform
            }}</span>
            <span
              class="awards__item"
              v-for="(award, index) in awards"
              :key="index"
            >
              <span class="ff-mono fs-12"
                >({{ award.amount.toString().padStart(2, '0') }})
              </span>
              <span>
                {{ award.award }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="awards__solo" data-split-context>
        <h4 data-split class="awards__label ff-mono tt-u fs-12 sp-45">
          {{ soloTitle }}
        </h4>

        <div class="awards__col">
          <div
            class="awards__platform"
            v-for="(awards, platform) in groupedSolo"
            :key="platform"
          >
            <span class="awards__platform__title fs-12 sp-16 tt-u" data-split>{{
              platform
            }}</span>
            <span
              class="awards__item"
              v-for="(award, index) in awards"
              :key="index"
            >
              <span data-split class="ff-mono fs-12"
                >({{ award.amount.toString().padStart(2, '0') }})
              </span>
              <span data-split v-html="award?.award.split('\n').join('<br>')">
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { asHTML } = usePrismic();

import { computed } from 'vue';

const props = defineProps({
  projects: { type: Array, default: () => [] },
  solo: { type: Array, default: () => [] },
  projectsTitle: { type: String, default: null },
  soloTitle: { type: String, default: null },
});

const groupedProjects = computed(() => {
  return props.projects.reduce((acc, item) => {
    if (!acc[item.platform]) {
      acc[item.platform] = [];
    }
    acc[item.platform].push(item);
    return acc;
  }, {});
});

const groupedSolo = computed(() => {
  return props.solo.reduce((acc, item) => {
    if (!acc[item.platform]) {
      acc[item.platform] = [];
    }
    acc[item.platform].push(item);
    return acc;
  }, {});
});
</script>

<style lang="scss" scoped>
.awards {
  display: flex;
  flex-direction: column;
  position: relative;
}

.awards__content {
  display: flex;
  flex-direction: column;
  position: relative;

  gap: 6rem;

  @include mq(desktop) {
    display: grid;
    gap: fluidMap($spacing, 16);
    grid-template-columns: 60% 40%;
  }
}

.awards__label {
  display: flex;
}

.awards__col {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: fluidMap($spacing, 45);
}

.awards__platform__title {
  display: flex;
  color: var(--c-text-mid);
}

.awards__item {
  display: block;
  line-height: 120%;
  margin-bottom: 0.3em;
  white-space: break-spaces;
}

.awards__border-top {
  background: var(--c-text-alt);
  height: 1px;
  left: 0;
  margin-bottom: 1.6rem;
  top: 0;
  transform-origin: left;
  transform: scaleX(0);
  transition: transform 1s ease(smooth);
  width: 100%;

  .awards:has(.awards__projects.is-context-animating) & {
    transform: scaleX(1);
  }
}

.awards__projects {
  position: relative;

  &:after {
    content: '';
    background: var(--c-text-alt);
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transform-origin: top;
    transform: translateY(-1.6rem) scaleY(0);
    transition: transform 1s ease(smooth);
    width: 1px;

    .awards:has(.awards__solo.is-context-animating) & {
      transform: translateY(-1.6rem) scaleY(1);
    }
  }

  @include mqDown(desktop) {
    &::after {
      content: none;
    }
  }
}

[data-split-context] {
  // background: rgba(255, 0, 0, 0.2);
}

.awards__item {
  display: flex;
  gap: 2rem;
  align-items: baseline;
}
</style>
